import { render, staticRenderFns } from "./editarDadosUsuario.vue?vue&type=template&id=167341ec&"
import script from "./editarDadosUsuario.vue?vue&type=script&lang=js&"
export * from "./editarDadosUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports